<template>
    <div class="content with-pagination">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Livraisons & retraits</h1>
                    <p>Gestion des méthodes de livraisons et retraits</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>

              <actions-dropdown>
                <li v-if="$aclInterfaceValidator('weeboxshop.shipping.create')" class="main" @click="create()">
                  <icon name="file-plus-02"/>
                  <span>Créer une livraison</span>
                </li>
                <li v-if="$aclInterfaceValidator('weeboxshop.shipping.import')" @click="importFile()">
                  <icon name="upload-cloud-01"/>
                  <span>Importer</span>
                </li>
              </actions-dropdown>


            </div>
        </header>

        <filters v-model="filters" :paginator="paginator" :tabs="tabsFilter" @refresh="refresh()" @setFilter="setFilter"></filters>

        <div class="content-body">

            <section>

                <no-results v-model="resources" :clear="resetFilter"></no-results>

                <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                    <div class="datagrid-header">
                        <div>
                            <div></div>
                            <div class="picture"></div>
                            <div class="center">
                              <datagrid-sort :data="[{name:'ID', value:'id'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div>
                              <datagrid-sort :data="[{name:'Nom', value:'name'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div>
                              <datagrid-sort :data="[{name:'Ordre', value:'ord'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div>
                              <datagrid-sort :data="[{name:'Transporteur', value:'transporter_id'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div v-bind:class="[ paginator.sort == 'cost_global' ? 'active' : '', paginator.order ]">
                              <datagrid-sort :data="[{name:'Prix '+price, value:'cost_global'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div><span>Statut</span></div>
                            <div><span>Scopes</span></div>
                            <div class="actions"></div>
                            <div></div>
                        </div>
                    </div>
                    <div class="datagrid-body">
                        <div v-for="item in resources" @dblclick="edit(item.id)" v-bind:class="setClassDataRaw( 'weeboxshop.shipping.view', item.id )">
                            <div></div>
                            <div class="picture no-radius">
                                <figure>
                                  <icon name="truck-01" v-if="item.type=='delivery'"/>
                                  <icon name="package" v-else-if="item.type=='shipping'"/>
                                  <icon name="marker-pin-04" v-else/>
                                </figure>
                            </div>
                            <div data-field="id" class="center"><span class="id">{{ item.id }}</span></div>
                            <div data-field="name">
                              <strong class="highlight">{{ item.name }}</strong>
                              <p>{{ item.headline }}</p>
                              <p>Livraison entre {{ $helpers.humanize(item.duration_estimate_min) }} et {{ $helpers.humanize(item.duration_estimate_max) }}</p>
                              <ul class="listing">
                                <li v-for="country in item.countries"><img :src="'/src/assets/flags/'+country.id.toLowerCase()+'.svg'" width="24" :title="country.name" style="border: 1px solid #aaa;"></li>
                              </ul>
                            </div>
                            <div data-field="ord">{{ item.ord }}</div>
                            <div data-field="transporter_id">
                                <img v-if="item.transporter && item.transporter.picture" :src="item.transporter.picture.url+'/resize/200xauto'" width="60"/>
                                <span v-if="!item.transporter || !item.transporter.picture">{{ item.transporter ? item.transporter.name : '-' }}</span>
                            </div>
                            <div data-field="cost_global">
                              <span class="price"><i>{{ currency }}</i> {{ item.cost_global|formatNumber }}</span>
                            </div>
                            <div><published v-model="item.published"></published></div>
                            <div data-field="scope"><scopes v-model="item.scopes" v-if="item.scopes"></scopes></div>
                            <div class="actions">
                                <ul>
                                    <li v-if="$aclInterfaceValidator('weeboxshop.shipping.delete',item.id)"><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                  <li v-if="$aclInterfaceValidator('weeboxshop.shipping.update',item.id)"><button @click="duplicate(item.id)" title="Dupliquer"><icon name="copy-07"/></button></li>
                                    <li v-if="$aclInterfaceValidator('weeboxshop.shipping.update',item.id)"><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                                </ul>
                            </div>
                            <div></div>
                        </div>
                    </div>
                </div>

            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import ShippingService from './ShippingService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
                price: null,
                tabsFilter: []
            }
        },
        mounted: function(){
            this.refresh()
            this.currency = this.$store.state.scope.currency_id
            this.price = (this.$store.state.scope.is_ttc?'TTC':'HT')
        },
        methods: {
            getResource: function(){
                return ShippingService;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/shop/shipping/Index.vue